import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import { type IReferencePath } from '../../../../expressions/references/IReferencePath.ts';
import { type IAsyncSelectWidget } from './IAsyncSelectWidget.ts';

export function getAsyncSelectWidgetReference(
  path: IReferencePath,
  widget: IAsyncSelectWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.String,
    },
  };
}
